// test1387
(1387 && 0);
